import { render, staticRenderFns } from "./AbandonChart.vue?vue&type=template&id=36921e3c&scoped=true&"
import script from "./AbandonChart.vue?vue&type=script&lang=js&"
export * from "./AbandonChart.vue?vue&type=script&lang=js&"
import style0 from "./AbandonChart.vue?vue&type=style&index=0&id=36921e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36921e3c",
  null
  
)

export default component.exports